<template>
  <div>
    <h1>Admin Banners</h1>
   {{this.$store.state.user}}
  </div>
</template>

<script>
  export default {
  }
</script>

<style scoped>

</style>
